/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Files_Add_Selected_CountInputs */

const en_files_add_selected_count = /** @type {(inputs: Files_Add_Selected_CountInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Add ${i?.count} file`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`Add ${i?.count} files`);
	return /** @type {LocalizedString} */ ("files_add_selected_count");
};

const es_files_add_selected_count = /** @type {(inputs: Files_Add_Selected_CountInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Agregar ${i?.count} archivo`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`Agregar ${i?.count} archivos`);
	return /** @type {LocalizedString} */ ("files_add_selected_count");
};

/**
* | countPlural | output |
* | --- | --- |
* | "one" | "Add {count} file" |
* | "other" | "Add {count} files" |
*
* @param {Files_Add_Selected_CountInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const files_add_selected_count = /** @type {((inputs: Files_Add_Selected_CountInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Files_Add_Selected_CountInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_files_add_selected_count(inputs)
	return en_files_add_selected_count(inputs)
});